import React from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { Col, Cols, IndependentSelect } from '~/src/dash/publicaUI';
import { isPhiloPublisher, isSamsungNAPublisher, isTestPublisher } from '~/src/dash/utils/ui';

const defaultPriorityOptions: ISelectOption[] = [
  // { id: -1, label: 'None' }, // Deals Only
  // { id: 11, label: '0' }, // Samsung / Test Only
  { id: 10, label: 'Tier 1' },
  { id: 9, label: 'Tier 2' },
  { id: 8, label: 'Tier 3' },
  { id: 7, label: 'Tier 4' },
  { id: 6, label: 'Tier 5' },
  { id: 5, label: 'Tier 6' },
  { id: 4, label: 'Tier 7' },
  { id: 3, label: 'Tier 8' },
  { id: 2, label: 'Tier 9' },
  { id: 1, label: 'Tier 10' },
  // { id: 0, label: '11' },
];

export const generatePriorityList = (publisherID: string): ISelectOption[] => {
  const priorityOptions: ISelectOption[] = [{ id: -1, label: 'None' }];
  if (
    isSamsungNAPublisher(publisherID) ||
    isPhiloPublisher(publisherID) ||
    isTestPublisher(publisherID)
  ) {
    priorityOptions.push({ id: 11, label: 'Tier 0' });
  }
  priorityOptions.push(...defaultPriorityOptions);
  return priorityOptions;
};

interface IProps {
  publisherID: string;
  selectedTier: number;
  handlePriorityChange: (tierSet: Set<number>) => void;
}

export const DealPrioritySelect = ({ publisherID, selectedTier, handlePriorityChange }: IProps) => {
  return (
    <Cols style={{ alignItems: 'center' }}>
      <Col width={170}>Deal Tier:</Col>
      <Col>
        <IndependentSelect
          handleApplySelect={handlePriorityChange}
          placeholder='Select Priority Tier'
          listLabel='Priority Tiers'
          singularLabel='Priority Tier'
          selectedLimit={1}
          disableSort
          isSelectionRequired
          options={generatePriorityList(publisherID)}
          selectedOptionIDs={new Set(selectedTier !== undefined ? [selectedTier] : [-1])}
          key='priority'
          maxWidth={480}
        />
      </Col>
    </Cols>
  );
};
